import React from "react";
import {
  TouchableOpacity,
  View,
  Text,
  StyleSheet,
  Platform,
} from "react-native";
import moment from "moment";
import AppTheme from "../../AppTheme";

import ImageComponent from "../../../v3/common/ImageComponent";
import UsersHelper from "../../users/UsersHelper";
import ReportHours from "./ReportHours";
import TeamIconGradient from "../../common/icons/TeamIconGradient";

import FORMATS from "../../reflection/header/formats";
import Utils from "../../../../helpers/utils";
import ReportCommentIcon from "./ReportCommentIcon";

export default function ReportItem({
  report,
  user,
  type,
  isTeamReport = false,
  isCardReport = false,
  editReport = () => {},
  //showReportUsers = () => {},
  controller,
}) {
  const hours = report.minutes != null ? Math.round(report.minutes / 60) : null;
  const timeUnit = report.time_unit || "week";

  let date = moment(report.reference_day);
  if (timeUnit == "week") date.add(6, "days");

  const reportDate = Utils.formatDateByTimeUnit({
    date: date.format("YYYY-MM-DD"),
    format: FORMATS[timeUnit]?.reportFormat,
    timeUnit,
    prefix: "ending",
  });

  const displayUserText = UsersHelper.getUsersHeaderText(
    report.users,
    type === "sent" ? "To: " : "",
  );

  const hasMultipleReceivers = type === "sent" && report.users?.length > 1;

  return (
    <View
      style={[
        styles.reportItem,
        isTeamReport
          ? styles.teamReportItem
          : isCardReport
          ? styles.cardReportItem
          : styles.shadow,
      ]}
    >
      <TouchableOpacity
        style={[styles.left]}
        onPress={() => editReport(report)}
      >
        {/* Avatar */}
        {isTeamReport ? null : hasMultipleReceivers ? (
          <TeamIconGradient style={styles.avatar} />
        ) : user ? (
          <ImageComponent image={user.avatar} style={styles.avatar} />
        ) : (
          <View style={styles.avatar} />
        )}

        {/* Hours */}
        <ReportHours mood={report.mood} hours={hours} />
      </TouchableOpacity>

      <TouchableOpacity style={styles.right} onPress={() => editReport(report)}>
        {/* User name */}
        <Text
          style={[styles.reportName]}
          numberOfLines={1}
          //onPress={() => showReportUsers(report.users)}
        >
          {displayUserText}
        </Text>

        {/* Date */}
        {isTeamReport ? null : (
          <View style={styles.row}>
            <Text style={styles.thin}>{reportDate}</Text>

            {/* Hours */}
            {hours && false ? (
              <Text style={styles.thin}> | {hours} hrs</Text>
            ) : null}
          </View>
        )}

        {/* Description */}
        <Text style={styles.info} numberOfLines={2}>
          {report.description}
        </Text>
      </TouchableOpacity>

      <ReportCommentIcon
        report={report}
        styles={styles.reportIcon}
        controller={controller}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  reportItem: {
    position: "relative",
    height: 76,
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    paddingRight: 8,
  },
  cardReportItem: {
    flex: 1,
    marginLeft: -10,
  },
  shadow: {
    shadowOpacity: 0.1,
    shadowOffset: { width: 0, height: 4 },
    shadowColor: "#000",
    shadowRadius: 3,
    elevation: 5,
    borderRadius: 4,
    backgroundColor: "#FFF",
    marginBottom: 8,
  },
  teamReportItem: {
    height: 52,
    borderBottomColor: AppTheme.borderColor,
    borderBottomWidth: 1,
    paddingVertical: 6,
  },
  flex: {
    display: "flex",
  },
  row: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
  },
  left: {
    display: "flex",
    alignItems: "center",
    marginHorizontal: 8,
    paddingVertical: 8,
  },
  right: {
    position: "relative",
    display: "flex",
    flex: 1,
    paddingRight: 32,
  },
  reportIcon: {
    height: "100%",
    width: 20,
  },
  avatar: {
    width: 28,
    height: 28,
    borderRadius: 28,
    marginBottom: 4,
  },
  reportName: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    marginBottom: 2,
  },
  info: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
  },
  thin: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "300",
    fontSize: 10,
    lineHeight: 12,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    marginBottom: 3,
  },
});
